import { isDefined } from "@clipboard-health/util-ts";
import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";

import { type WorkerStatusResponse, workerStatusResponseSchema } from "../types";

const WORKER_HOME_HEALTH_ENABLED_URL = `${environmentConfig.REACT_APP_HOME_HEALTH_API_URL}/v1/:workplaceId/workers/:workerId`;

export function getWorkerHomeHealthEnabledQueryKey(params: {
  workplaceId: string;
  workerId: string;
}) {
  return [
    WORKER_HOME_HEALTH_ENABLED_URL.replace(":workplaceId", params.workplaceId).replace(
      ":workerId",
      params.workerId
    ),
    null,
  ];
}

export function useIsWorkerHomeHealthEnabled(
  workerId: string,
  options: UseGetQueryOptions<WorkerStatusResponse> = {}
) {
  return useGetQuery({
    url: WORKER_HOME_HEALTH_ENABLED_URL.replace(":workplaceId", workerId).replace(
      ":workerId",
      workerId
    ),
    responseSchema: workerStatusResponseSchema,
    retry: 0,
    staleTime: 1000 * 60 * 5,
    refetchInterval: 1000 * 60 * 10,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.HOME_HEALTH_GET_WORKER_ENABLED_FAILURE,
    },
    enabled: isDefined(workerId) && typeof workerId === "string",
    ...options,
  });
}
